/**
 * Describes why a document is being generated.
 */
enum ExportableFileGenerationIntent {
    Preview = 1,
    Fax,
    Print,
    Sign,
    UseSignedCopy,
    SendToPortal
}

export { ExportableFileGenerationIntent };
